import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { ENABLE_CATEGORY_LINK_TOGGLE_FULL_PAGE_PREFETCHING_250320 } from "@faire/web-api--source/indigofair/settings/ENABLE_CATEGORY_LINK_TOGGLE_FULL_PAGE_PREFETCHING_250320";

export const useSettingEnableCategoryPrefetchLinkToggle = () =>
  useSetting(ENABLE_CATEGORY_LINK_TOGGLE_FULL_PAGE_PREFETCHING_250320, {
    surfaces: {
      categoriesForYou: { enabled: false, threshold: 800 },
      filterToggle: { enabled: false, threshold: 800 },
      headerDropdown: { enabled: false, threshold: 800 },
      sideNav: { enabled: false, threshold: 800 },
      topNav: { enabled: false, threshold: 800 },
      visualNav: { enabled: false, threshold: 800 },
      default: { enabled: false, threshold: 800 },
    },
  });
